export default {
  name: "Additional Job Opportunity Information and Other Requirements",
  prefix: "G",
  pageInfo: {
    isVisible: {
      when: "occupationType",
      is: [
        "professional_occupation",
        "non_professional",
        "college_university_teacher",
        "",
      ],
      hideStyles: true,
      operator: "||",
    },
    text: `<b>IMPORTANT INSTRUCTIONS FOR QUESTIONS 6 THROUGH 12<br/><br/>
    For each question marked “Yes,” the employer <u>must complete one (1) section</u> of the Form ETA-9089 – Appendix C to \
    provide a brief explanation justifying the response.</b>
    `,
    coloring: "grey",
  },
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        isVisible: {
          when: "occupationType",
          is: ["professional_athlete"],
          operator: "||",
        },
        title: "Section Complete",
        description: `Because you indicated that this application is for a professional athlete, 
          G.1 – G.5 is not required to be completed.  Please complete required fields G.6 – G.12.`,
        type: "success",
      },
    ],
  },
  sections: [
    {
      isVisible: {
        when: "occupationType",
        is: [
          "professional_occupation",
          "non_professional",
          "college_university_teacher",
          "",
        ],
        hideStyles: true,
        operator: "||",
      },
      fields: [
        {
          isGroup: {
            code: "G.1",
            machine_name: "isFullTimeEmp",
            required: true,
            label: `Is this a permanent position offering full-time employment of generally 35 hours or more?`,
            tooltip:
              "If the job opportunity is a full-time position (generally 35 hours or more), mark “Yes.”  Otherwise, mark “No.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["isFullTimeEmp"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.2",
            machine_name: "isLiveInHousehold",
            required: true,
            label: `Is the employer seeking permanent labor certification for a live-in household domestic service worker?`,
            tooltip:
              "If the job opportunity is for a live-in household domestic service worker, mark “Yes.”  Otherwise, mark “No.”  A live-in domestic household service worker is a worker who resides at and performs job duties in or around the employer's private home.  The employer's private home may be a fixed place of residence or a temporary dwelling, if traveling or on vacation.  Any separate and distinct dwelling occupied by the employer—which may take the form of a house, apartment, condominium, hotel, etc.—may be considered a private home.",
            clearBtn: {
              clearSchema: [
                "isLiveInHousehold",
                "isPaidExperience",
                "isFwexecutedCont",
                "isEmpProvidedCont",
              ],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                setSchema: [
                  { set: "isPaidExperience", to: "N/A" },
                  { set: "isFwexecutedCont", to: "N/A" },
                  { set: "isEmpProvidedCont", to: "N/A" },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.2a",
            machine_name: "isPaidExperience",
            label: `If "Yes" is marked in question G.2, indicate whether the foreign worker possesses one year of paid \
            experience as a live-in household domestic service worker? §`,
            tooltip:
              "If “Yes” to question G.2, indicate whether the foreign worker has a total of one year of paid experience as a live-in domestic service worker by marking “Yes” or “No.”  If the answer to question G.2 is “No,” mark “N/A.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["isPaidExperience"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.2b",
            machine_name: "isFwexecutedCont",
            label: `If “Yes” is marked in Question G.2, indicate whether the employer and foreign worker 
            have executed the required employment contract? §`,
            tooltip:
              "If “Yes” to question G.2, indicate whether the employer and the foreign worker have executed (signed and dated) an employment contract, as described in 20 CFR 656.19(b)(2), by marking “Yes” or “No.”  If the answer to question G.2 is “No,” mark “N/A.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["isFwexecutedCont"],
            },
            validate: [
              {
                isRequired: "isLiveInHousehold",
                message: "This field is required",
                needsFieldValues: true,
                extraData: {
                  valueOf: "Yes",
                },
              },
            ],
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.2c",
            machine_name: "isEmpProvidedCont",
            label: `If “Yes” is marked in Question G.2b, indicate whether the employer provided a copy of the
            employment contract to the foreign worker? §`,
            tooltip:
              "If “Yes” to question G.2b, indicate whether the employer has provided the foreign worker with a copy of the executed employment contract, as described in 20 CFR 656.19(b)(2), by marking “Yes” or “No.”  If the answer to question G.2 is “No” mark “N/A.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["isEmpProvidedCont"],
            },
            validate: [
              {
                isRequired: "isLiveInHousehold",
                message: "This field is required",
                needsFieldValues: true,
                extraData: {
                  valueOf: "Yes",
                },
              },
            ],
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: [
                  {
                    isRequired: "isLiveInHousehold",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.3",
            machine_name: "acceptDiplomaPwd",
            required: true,
            label: `Will the employer accept a foreign diploma/degree equivalent to the employer's required U.S. diploma/degree identified in Section F of the PWD identified in question E.1?`,
            tooltip:
              "Indicate whether the employer will accept a foreign diploma or degree equivalent to the U.S. diploma or degree identified in Section F of the PWD and identified in Question E.1 of this form by marking “Yes” or “No.”  Otherwise, mark “N/A.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["acceptDiplomaPwd"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.4",
            machine_name: "isFwCurrentlyWrk",
            required: true,
            label: `Is the foreign worker currently working for the employer submitting this application?`,
            tooltip:
              "Indicate whether the foreign worker is employed by the employer listed in this application by marking “Yes” or “No.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["acceptDiplomaPwd", "isFwQualify", "empWillAccept"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
                setSchema: [{ set: "isFwQualify", to: null }],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                setSchema: [{ set: "isFwQualify", to: "N/A" }],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.4a",
            machine_name: "isFwQualify",
            label: `If "Yes" in question G.4, indicate whether the foreign worker only qualifies for the job opportunity by the virtue of the employer's alternative requirements identified in Section F of the PWD identified in Question E.1. §`,
            tooltip:
              "If “Yes” to question G.4, indicate whether the foreign worker only qualifies for the job opportunity by virtue of the employer's alternative requirements identified in Section F of the PWD identified in Question E.1 by marking “Yes” or “No.”  Otherwise, mark “N/A.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["isFwQualify"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: [
                  {
                    isRequired: "isFwCurrentlyWrk",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: [
                  {
                    isRequired: "isFwCurrentlyWrk",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: [
                  {
                    isRequired: "isFwCurrentlyWrk",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.4b",
            machine_name: "empWillAccept",
            label: `If "Yes" in question G.4 and G.4a, please select the applicable statement describing the employer's willingness to accept any suitable combination of education, experience, or training. §`,
            tooltip: `If “Yes” to questions G.4 and G.4a <u>and</u> the employer is willing to accept any suitable combination of education, experience, or training, mark “I ACCEPT.”  If “Yes” in questions G.4 <u>and</u> G.4a, but the 
            employer is <u>not</u> willing to accept any suitable combination of education, experience, or training, mark “I <b><u>DO NOT</u></b> ACCEPT.”
            <br/><br/>
            <b><u>Note:</u></b> For more information on “suitable combination,” read the Board of Alien Labor Certification Appeals decision in the <i>Matter of Francis Kellogg</i>, 1994 INA 00465 (Feb. 2, 1998) (<i>en banc</i>). `,
            coloring: "none",
            clearBtn: {
              clearSchema: ["empWillAccept"],
            },
            fields: [
              {
                widget: "radio",
                choice: "I ACCEPT",
                value: "Yes",
                validate: [
                  {
                    isRequired: "isFwQualify",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "I DO NOT ACCEPT",
                value: "No",
                validate: [
                  {
                    isRequired: "isFwQualify",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.5",
            machine_name: "empRelyExp",
            required: true,
            label: `Is the employer relying solely on the experience the foreign worker gained while working for the employer, including as a contract employee to qualify him/her for the job opportunity covered by this application?`,
            tooltip:
              "Indicate whether the employer is relying solely on the experience the foreign worker gained while working for the employer, including as a contract employee to qualify him/her for the job opportunity covered by this application by marking “Yes” or “No.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["empRelyExp", "fwGainExp", "empPayEducation"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
                setSchema: [
                  { set: "fwGainExp", to: null },
                  { set: "empPayEducation", to: null },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                setSchema: [
                  { set: "fwGainExp", to: "N/A" },
                  { set: "empPayEducation", to: "N/A" },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.5a",
            machine_name: "fwGainExp",
            label: `If “Yes” in Question G.5, did the foreign worker gain any of the qualifying experience with the employer in a position <u>substantially comparable</u> to the job opportunity identified in Section F of the PWD identified in Question E.1? §`,
            tooltip: `If “Yes” to question G.5, indicate whether the foreign worker gained any of the qualifying experience with the employer in a position <u>substantially comparable</u> to the job opportunity identified in Section F of the PWD and identified in Question E of the Form ETA-9089.  If “Yes” in question G.5, <u>but</u> the foreign worker did <u>not</u> gain any of the qualifying experience with the employer in a position substantially comparable to the job opportunity, mark “No.”  If the answer to question G.5 is “No,” mark “N/A.”

            <br/><br/><u><b>Note:</b></u> A <u>substantially comparable</u> position/job is one that requires performance of the same job duties as the foreign worker’s current position/job with the employer more than 50% of the time.  If “Yes” is marked for this question, please be prepared to provide documentation, upon request from the Certifying Officer, demonstrating why it is no longer feasible to train a U.S. worker to qualify for the position.`,
            coloring: "none",
            clearBtn: {
              clearSchema: ["fwGainExp"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: [
                  {
                    isRequired: "empRelyExp",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: [
                  {
                    isRequired: "empRelyExp",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: [
                  {
                    isRequired: "empRelyExp",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.5b",
            machine_name: "empPayEducation",
            label: `If “Yes” in Question G.5, did the employer pay for any of the foreign worker’s education or 
            training necessary to satisfy any of the employer’s requirements for the job opportunity 
            identified in Section F of the PWD identified in Question E.1? §`,
            tooltip:
              "If “Yes” to question G.5, indicate whether the employer paid for any education or training that qualified the foreign worker for the job opportunity by marking “Yes” or “No.”  If “Yes” in question G.5, <u>but</u> the employer did <u>not</u> pay for any education and/or training that qualified the foreign worker for the job opportunity, mark “No.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["empPayEducation"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: [
                  {
                    isRequired: "empRelyExp",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: [
                  {
                    isRequired: "empRelyExp",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: [
                  {
                    isRequired: "empRelyExp",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: "Yes",
                    },
                  },
                ],
              },
            ],
          },
        },
      ],
    },
    {
      coloring: "grey",
      fields: [
        {
          widget: "jump_to_step",
          label: `<b>IMPORTANT:</b> if "Yes” is marked in any of the questions below, complete the respective section of the Form ETA-9089, <b>Appendix C</b> to provide a brief explanation justifying response.`,
          jump_to_step: {
            buttonPrimary: "Go to Appendix C",
            step: 21,
          },
        },
      ],
    },
    {
      fields: [
        {
          isGroup: {
            code: "G.6",
            machine_name: "jobEmpPremises",
            required: true,
            label: `Does the job opportunity require the worker to live on the employer's premises?`,
            tooltip:
              "Indicate whether the employer’s job opportunity requires the foreign worker to live on the employer's premises by marking “Yes” or “No.”",
            coloring: "none",
            clearBtn: {
              clearSchema: ["jobEmpPremises"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.6",
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.7",
            machine_name: "jobComboOccup",
            required: true,
            label: `Does the job opportunity in Section F of the PWD identified in Question E.1 involve a combination of occupations?`,
            tooltip: `Indicate whether the employer’s job opportunity involves a combination of occupations (e.g., engineer/pilot) by marking “Yes” or “No.”
              <br/><br/><u><b>Note:</b></u> If “Yes” is marked for this question, please use Appendix C to explain briefly how the combination is supported by business necessity, 
              the employer has normally employed persons for that combination of occupations, and/or workers 
              customarily perform the combination of occupations in the area of intended employment.`,
            coloring: "none",
            clearBtn: {
              clearSchema: ["jobComboOccup"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.7",
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.8",
            machine_name: "jobForeignLanguage",
            required: true,
            clearBtn: {
              clearSchema: ["jobForeignLanguage"],
            },
            label: `Is proficiency in a foreign language required or preferred to perform the job duties identified in Section F of the PWD identified in Question E.1?`,
            tooltip: `Indicate whether proficiency in a foreign language is required or preferred by the employer in order for the worker to perform the job duties described in the job opportunity by marking “Yes” or “No.”

            <br/><br/><u><b>Note:</b></u> If “Yes” is marked for this question, please use Appendix C to explain briefly how the foreign language requirement is supported by business necessity.`,
            coloring: "none",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.8",
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.9",
            machine_name: "jobReqExceed",
            required: true,
            label: `Do the job requirements identified in Section F of the PWD identified in Question E.1 exceed the Specific Vocational Preparation (SVP) level assigned to the occupation as shown in the O*NET Job Zones?`,
            tooltip: `Indicate whether the employer’s job requirements exceed the Specific Vocational Preparation (SVP) level assigned to the occupation, 
              as shown in the O*NET Job Zones, by marking “Yes” or “No.” 
              <br/><br/><u><b>Note:</b></u> If “Yes’ is marked for this question, please use Appendix C to explain briefly how the job requirements are supported by business necessity.`,
            coloring: "none",
            clearBtn: {
              clearSchema: ["jobReqExceed"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.9",
                  },
                ],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.9",
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.10",
            machine_name: "empUseCredential",
            required: true,
            label: `Did the employer use a credentialing service to qualify the foreign worker's education and/or experience requirements in Section F of the PWD identified in Question E.1?`,
            tooltip: `Indicate whether the employer used a credentialing service to qualify the foreign worker’s education and/or experience for the job opportunity by marking “Yes” or “No.”
            <br/><br/><u><b>Note:</b></u> If “Yes” is marked for this question, please use Appendix C to explain briefly what experience, education, or combination of both was used to qualify the foreign worker for the minimum requirements.  
            For example, the credentialing service accepted two (2) years of experience in lieu of a bachelor’s degree.  Per 20 CFR 656.3, if the employer is willing to accept work experience in lieu of a baccalaureate or higher degree, such work 
            experience must be attainable in the U.S. labor market and must be stated on the application form.  If the employer is willing to accept an equivalent foreign degree, 
            the employer must state this clearly on the Form ETA-9089, <i>Application for Permanent Employment Certification</i>.`,
            coloring: "none",
            clearBtn: {
              clearSchema: ["empUseCredential"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.10",
                  },
                ],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.10",
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.11",
            machine_name: "emprecpayment",
            required: true,
            label: `Has the employer received payment of any kind for the submission of this application?`,
            tooltip: `Indicate whether the employer has received any kind of payment or service in-kind for preparing and submitting this application by marking “Yes” or “No.”
              <br/><br/><u><b>Note:</b></u> If “Yes” is marked for this question, please use Appendix C to include a brief explanation of who paid the employer and an explanation of 
              services for which the payment was received, including the amount and the date of the contract, if applicable.  The explanation should also include a statement 
              regarding if the payment was received as an incentive, inducement, or reimbursement for filing the application and if the payment is associated with the employer’s 
              attorney fees or other related activities as indicated in 20 CFR 656.12(b).  The explanation must indicate whether the same attorney represents both the 
              employer and the foreign worker.  Payment includes, but is not limited to, monetary payments; wage concessions, including deductions from wages, salary, or 
              benefits; kickbacks, bribes, or tributes; in-kind payments; and free labor.`,
            coloring: "none",
            clearBtn: {
              clearSchema: ["emprecpayment"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.11",
                  },
                ],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.12",
            machine_name: "emPlayoff",
            required: true,
            label: `Has the employer had a layoff in the occupation involved in this application or in a related occupation within the 6 months immediately preceding the filing of this application in the area of intended employment?`,
            tooltip: `Indicate whether the employer had a layoff in the occupation involved in this application or in a related occupation within the six (6) months immediately preceding the filing of this application in the area of intended employment by marking “Yes” or “No.”
            <br/><br/><u><b>Note:</b></u> If “Yes” is marked for this question, please use Appendix C to explain briefly the nature of the layoff specifying the job title(s), job location(s), and the number of employees laid off.  
            The explanation should also include how the laid off employees were notified of the job opportunity listed in this application. `,
            coloring: "none",
            clearBtn: {
              clearSchema: ["emPlayoff"],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearTableRows: [
                  {
                    table: "appCSupp",
                    field: "sectionAndItemNum",
                    find: "G.12",
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  ],
};
